<template>
  <div :class="{ header: !isCart, 'header-cart': isCart }">
    <NavLogo v-if="!isCart" />
    <NavLogoFull v-else />
  </div>
</template>

<script>
import { computed } from "vue";
import NavLogo from "@/components/nav/NavLogo";
import NavLogoFull from "@/components/nav/NavLogoFull";
import router from "@/router";

export default {
  name: "NavTopAnon",
  components: {
    NavLogo,
    NavLogoFull,
  },
  setup() {
    const isCart = computed(() => router?.currentRoute?.value?.meta?.cart);

    return { isCart };
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";

// .header,
// .header-cart {
//   height: $header-height;
// }
</style>
